import { MemberListWrapperMobile } from './styles';
import { useState, useEffect } from 'react';
import { userBetsRecordState } from '../state';
import { useAtomValue } from 'jotai';
import { RewardRecord } from '../types';
import MemberItem from './MemberItem';
import DelayFadeOut from '@/components/features/casino/rush/WinningBroadcast/DelayFadeOut';
import { useUser } from '@/state/userInfo/hooks';

export default function MobileBlinkingOnlinePlayers() {
  const [curList, setCurList] = useState<RewardRecord[]>([]);
  const list = useAtomValue(userBetsRecordState);
  const { isCurrentUser, name } = useUser();

  function formatRushRecords(list: RewardRecord[]) {
    return list.map((item, index) => {
      return {
        ...item,
        userName: isCurrentUser(item.uid || item.userId) ? name : item.userName,
      };
    });
  }

  useEffect(() => {
    if (list.length === 0) {
      setCurList([]);
      return;
    }
    setCurList(formatRushRecords([list[list.length - 1]]));
  }, [list.length]);

  return (
    <MemberListWrapperMobile>
      {curList.map((item) => {
        return (
          <DelayFadeOut key={item.createdTime}>
            <MemberItem
              key={item.createdTime}
              opacity={1}
              item={item}
              style={{
                background: 'rgba(44, 44, 53, 0.60)',
              }}
            />
          </DelayFadeOut>
        );
      })}
    </MemberListWrapperMobile>
  );
}
